<template>
    <div class="bg-white">
        <header>
            <div class="relative bg-gray-800">
                <div
                    class="flex justify-between items-center max-w-7xl mx-auto px-4 py-6 sm:px-6 md:justify-start md:space-x-10 lg:px-8"
                >
                    <div class="flex justify-start lg:w-0 lg:flex-1">
                        <inertia-link href="/">
                            <span class="sr-only">Tichit</span>
                            <img class="h-8 w-auto sm:h-10" src="/svg/logo.svg" alt="logo" />
                        </inertia-link>
                    </div>
                    <div class="hidden space-x-8 md:flex md:ml-10">
                        <inertia-link
                            :href="route('landing.about')"
                            class="text-base font-medium text-white hover:text-gray-300"
                        >
                            {{ $t('messages.about_us') }}
                        </inertia-link>
                    </div>
                    <div class="hidden space-x-8 md:flex md:ml-10">
                        <InertiaLink
                            href="/resources/activities/practice"
                            class="text-base font-medium text-white hover:text-gray-300"
                        >
                            {{ $t('messages.turing') }}
                        </InertiaLink>
                    </div>
                    <div class="hidden space-x-8 md:ml-10">
                        <InertiaLink
                            :href="route('landing.activities.index')"
                            class="text-base font-medium text-white hover:text-gray-300"
                        >
                            {{ $tc('messages.resources', 2) }}
                        </InertiaLink>
                    </div>
                    <div class="hidden space-x-8 md:flex md:ml-10">
                        <inertia-link href="/esfera" class="text-base font-medium text-white hover:text-gray-300">
                            Esfera
                        </inertia-link>
                    </div>
                    <div class="-mr-2 -my-2 hidden">
                        <!-- sidebar -->
                        <button
                            type="button"
                            class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                        >
                            <span class="sr-only">Open menu</span>
                            <!-- Heroicon name: menu -->
                            <svg
                                class="h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>
                    </div>
                    <nav class="hidden md:flex space-x-10">
                        <div class="relative">
                            <!-- Item active: "text-gray-900", Item inactive: "text-gray-500" -->
                            <button
                                type="button"
                                class="hidden group bg-white rounded-md text-gray-500 inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                <span>Solutions</span>
                                <!--
                                  Heroicon name: chevron-down

                                  Item active: "text-gray-600", Item inactive: "text-gray-400"
                                -->
                                <svg
                                    class="ml-2 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </button>

                            <!--
                              'Solutions' flyout menu, show/hide based on flyout menu state.

                              Entering: "transition ease-out duration-200"
                                From: "opacity-0 translate-y-1"
                                To: "opacity-100 translate-y-0"
                              Leaving: "transition ease-in duration-150"
                                From: "opacity-100 translate-y-0"
                                To: "opacity-0 translate-y-1"
                            -->
                        </div>

                        <a href="#" class="hidden text-base font-medium text-gray-500 hover:text-gray-900">
                            Partners
                        </a>
                        <a href="#" class="hidden text-base font-medium text-gray-500 hover:text-gray-900"> Company </a>
                    </nav>
                    <div class="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                        <a
                            href="#"
                            class="hidden whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900"
                        >
                            Sign in
                        </a>
                        <a
                            href="#"
                            class="hidden ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700"
                        >
                            Sign up
                        </a>
                    </div>
                    <div class="space-x-8 md:ml-10">
                        <a :href="route('login')" class="text-base font-medium text-white hover:text-gray-300">
                            <svg
                                class="block sm:hidden w-6 h-6"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <span class="hidden sm:block border border-2 hidden py-1.5 px-2.5 rounded-lg sm:block">
                                {{ $t('messages.login') }}
                            </span>
                        </a>
                    </div>
                    <div class="flex">
                        <inertia-link
                            v-for="locale in availableLocales"
                            :key="locale.code"
                            :href="
                                route('landing.language', {
                                    language: locale.code,
                                })
                            "
                        >
                            <span
                                :class="
                                    $i18n.locale === locale.code
                                        ? 'bg-indigo-600 text-indigo-100'
                                        : 'bg-gray-100 text-gray-800'
                                "
                                class="mr-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                            >
                                {{ locale.code }}
                            </span>
                        </inertia-link>
                    </div>
                </div>

                <!--
                  Mobile menu, show/hide based on mobile menu state.

                  Entering: "duration-200 ease-out"
                    From: "opacity-0 scale-95"
                    To: "opacity-100 scale-100"
                  Leaving: "duration-100 ease-in"
                    From: "opacity-100 scale-100"
                    To: "opacity-0 scale-95"
                -->
            </div>
        </header>
        <slot></slot>
        <footer class="bg-gray-700 text-white" aria-labelledby="footerHeading">
            <h2 id="footerHeading" class="sr-only">Footer</h2>
            <div class="max-w-md mx-auto px-4 sm:max-w-7xl sm:px-6 lg:px-8">
                <div class="pt-6 pb-6">
                    <div class="flex justify-center">
                        <SocialLinks size="xl" />
                    </div>
                    <p class="text-base text-gray-400 xl:text-center mt-3">&copy; 2024 Tichit. All rights reserved.</p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import SocialLinks from '@/components/Landing/SocialLinks.vue';

export default {
    components: { SocialLinks },
    name: 'LandingLayout',
    data() {
        return {
            availableLocales: [
                {
                    code: 'en',
                    name: 'English',
                },
                {
                    code: 'es',
                    name: 'Español',
                },
                {
                    code: 'ca',
                    name: 'Català',
                },
            ],
        };
    },
};
</script>
